import React, { useEffect, useState } from 'react'
import { PlanType } from './type'
import { useTranslation } from 'react-i18next'
import { RoomInfo } from '../room-info'
import { CheckInDate } from './CheckInDates'
import { usePlanStore } from '../../../store/planStore'

export const Plan = (props: { plan: PlanType }) => {
  const { plan } = props
  const { room, checkInDates } = plan
  const [isOpenDetail, setIsOpenDetail] = useState(false)
  const { t } = useTranslation()
  const { selectedPlan, selectedCheckInDate } = usePlanStore()

  if (!room) {
    return <></>
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const hasPreschoolerBirthdays = urlParams.has('preschooler_birthdays')
    if (selectedPlan && selectedPlan.planId === plan.planId && selectedCheckInDate && hasPreschoolerBirthdays) {
      const checkInDateAvailable = plan.checkInDates.find((checkInDate) => checkInDate.date === selectedCheckInDate.date)
      const elementAlert = document.getElementById('check-in-date-alert')
      if (elementAlert) {
        if (!checkInDateAvailable || checkInDateAvailable?.status !== 'OK') {
          elementAlert.classList.remove('hidden')
        } else {
          elementAlert.classList.add('hidden')
        }
      }
    }
  }, [selectedPlan, selectedCheckInDate, plan])

  return (
    <>
      {isOpenDetail && <RoomInfo room={room} close={() => setIsOpenDetail(false)} />}
      <div>
        <div className="flex gap-15px items-center justify-start ml-3 md:ml-0">
          <img src={room.images[0]} alt={room.name} className="w-full h-auto" style={{ width: '120px' }} />
          <div className="flex flex-col justify-between">
            <div className="text-green font-bold underline mb-2 cursor-pointer" onClick={() => setIsOpenDetail(true)}>
              {room.name}
            </div>
            {room.description && <div className="text-gray-500 mb-2">{room.description}</div>}
            <div className="flex gap-2">
              <div className="bg-gray-200 px-2 py-1 rounded-md text-xs">
                {t('landing_page.avaiability.room.max_capacity', { count: room.roomMaxCount })}
              </div>
              {room.foodText && <div className="bg-gray-200 p-1 rounded-md text-xs">{`食事${room.foodText}`}</div>}
            </div>
          </div>
        </div>
        <div className="flex gap-2 overflow-auto hidden-scrollbar mt-5 mb-6 px-3 md:pl-0 md:pr-3">
          {checkInDates.map((checkInDate, index) => (
            <CheckInDate plan={plan} checkInDate={checkInDate} key={`${plan.planId}-${checkInDate.date}`} />
          ))}
        </div>
      </div>
    </>
  )
}
